import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.FETCH_EXPORTS_REQUEST,
    SUCCESS: types.FETCH_EXPORTS_SUCCESS,
    FAILURE: types.FETCH_EXPORTS_FAILURE,
    CANCEL: types.FETCH_EXPORTS_CANCEL,
};

export default ReduxUtils.basicApiReducer({
    actionTypes,
});
